import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
  Modal,
} from "reactstrap";
//import DriversComponent from "../DriversOld/DriversComponent";
import "./SettlementsDetailsPOC.scss";
import Sidebar from "app/views/commonComponents/Sidebar/Sidebar";
import { Container } from "reactstrap";
import Breadcrumbs from "app/views/commonComponents/Breadcrumb/Breadcrumbs";
import Title from "app/views/commonComponents/Title/Title";
import DetailsHeader from "../../../../commonComponents/DetailsHeader/DetailsHeader";
import backRightArrow from "../../../../../../assets/images/poc/backRightArrow.svg";
import userIcon from "../../../../../../assets/images/poc/userIcon.svg";
import { Link } from "react-router-dom";
import QuickActionsDropdown from "app/views/commonComponents/QuickActionsDropdown/QuickActionsDropdown";
import driverProfile from "../../../../../../assets/images/drivers/driverProfile.svg";
import accidents from "../../../../../../assets/images/drivers/accidents.svg";
import calendarRemove from "../../../../../../assets/images/drivers/calendarRemove.svg";
import moneys from "../../../../../../assets/images/drivers/moneys.svg";
import presentionChart from "../../../../../../assets/images/drivers/presentionChart.svg";
import star from "../../../../../../assets/images/drivers/star.svg";
import userTag from "../../../../../../assets/images/drivers/userTag.svg";
import ProfilePOC from "../../ProfilePOC/ProfilePOC";
import searchIcon from "../../../../../../assets/images/poc/searchIcon.svg";
import DriversTablePOC from "../../TablePOC/TablePOC";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import AddOtherRevenue from "../AddOtherRevenue/AddOtherRevenue";
import optionsMenu from "../../../../../../assets/images/optionsMenu/optionsMenu.svg";
import grossRevenueGradient from "../../../../../../assets/images/poc/grossRevenueGradient.svg";
import grossMarginGradient from "../../../../../../assets/images/poc/grossMarginGradient.svg";
import rpmGradient from "../../../../../../assets/images/poc/rpmGradient.svg";
import driverPaymentsGradient from "../../../../../../assets/images/poc/driverPaymentsGradient.svg";
import milesLoadedGradient from "../../../../../../assets/images/poc/milesLoadedGradient.svg";
import loadsDeliveredGradient from "../../../../../../assets/images/poc/loadsDeliveredGradient.svg";
import {
  getSettelmentsDetailsHeaderKPIData,
  getSettlementsListData,
} from "app/apiServices/apiServices";
const SettlementsDetailsPOC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [maxTableHeight, setMaxTableHeight] = useState(0);
  const [settelmentsListOriginalData, setSettlementsListOriginalData] =
    useState([]);
  const [newSettlementDate, setNewSettelmentDate] = useState("");
  const [newUploadId, setNewUploadId] = useState();
  const [statementDate, setStatementDate] = useState("");
  const { settlementDate, uploadId } = useParams();
  const [showAddOtherRevenue, setShowAddOtherRevenue] = useState(false);
  const [grossRevenue, setGrossRevenue] = useState(0);
  const [driverPayments, setDriverPayments] = useState(0);
  const [grossMargin, setGrossMargin] = useState(0);
  const [headerRPM, setHeaderRPM] = useState(0);
  const [milesLoaded, setMilesLoaded] = useState(0);
  const [loadsDelivered, setLoadsDelivered] = useState(0);

  // Use the settlementDate and settelmentsUploadId as needed
  console.log("Settlement1", settlementDate);
  console.log("settelmentsUploadId", uploadId);
  const breadcrumbItems = [
    { title: "Settlements", link: "/settlement" },
    {
      title: statementDate ? `${statementDate}` : `${statementDate}`,
      link: `/settlement/${settlementDate}/${uploadId}`,
    },
  ];
  const driverData = [
    {
      icon: grossRevenueGradient,
      values: `$${Math.round(grossRevenue).toLocaleString("en-US")}`,
      title: "Gross Revenue",
    },
    {
      icon: driverPaymentsGradient,
      values: `$${Math.round(driverPayments).toLocaleString("en-US")}`,
      title: "Driver Payments",
    },
    {
      icon: grossMarginGradient,
      values: `$${Math.round(grossMargin).toLocaleString("en-US")}`,
      title: "Gross Margin",
    },
    {
      icon: rpmGradient,
      values: `$${headerRPM.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
      title: "RPM",
    },
    {
      icon: milesLoadedGradient,
      values: milesLoaded.toLocaleString("en-US"),
      title: "Loaded Miles",
    },
    {
      icon: loadsDeliveredGradient,
      values: loadsDelivered.toLocaleString("en-US"),
      title: "Delivered Loads",
    },
    //{ icon: accidents, values: "72", title: "Loads" },
    // { icon: calendarRemove, values: "13", title: "Near Expirations" },
    // { icon: moneys, values: "$3.54", title: "Avg. RPM" },
    // { icon: presentionChart, values: "86.3%", title: "Avg. RPM" },
    // Add more data items as needed
  ];
  const tabsData = [
    { id: 0, label: "Profile" },
    { id: 1, label: "Loads" },
    { id: 2, label: "Driver History" },

    // Add more tabs as needed
  ];
  const settlementsTableHeaders = {
    driverID: "Driver Id.",
    driverName: "Driver Name",
    loadsDelivered: "Loads",
    MilesLoaded: "Loaded Miles",
    rpm: "RPM",
    totalRevenue: "Load Revenue",
    totalOtherRevenue: "Other Revenue",
    totalDeduction: "Deductions",
    netPay: "Net Pay",
    status: "Status",
  };
  const settlementsTableData = settelmentsListOriginalData.map((driver) => ({
    driverID: driver.driver_id,
    driverName: driver.driver_name,
    loadsDelivered: driver.loads_delivered.toLocaleString(),
    milesLoaded: driver.loaded_miles.toLocaleString(),
    rpm: driver.rpm
      ? `$${driver.rpm.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "$0.00", // Formatting rpm with 2 decimal places
    totalRevenue: `$${driver.total_revenue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`,
    totalOtherRevenue: `$${driver.other_revenue_amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} •  ${driver.other_revenue_count.toLocaleString()}`,
    totalDeduction: `$${driver.deduction_amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} • ${driver.deduction_count.toLocaleString()}`,
    netPay: `$${driver.net_pay.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`,
    status: capitalizeFirstLetter(driver.status),
    settlementDate: settlementDate,
    uploadId: uploadId,
  }));
  const handleOpenAddOtherRevenue = () => {
    setShowAddOtherRevenue(true);
  };
  const handleCloseAddOtherRevenue = () => {
    setShowAddOtherRevenue(false);
  };
  function handleButtonClick(driver) {
    // Handle button click here, you can access the driver data
    console.log("Button clicked for driver:", driver);
  }
  // Function to capitalize the first letter of a string
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };
  useEffect(() => {
    handleReturnSettlementsDetailsPOC();
    const calculateMaxTableHeight = () => {
      // Get the window height
      const windowHeight = window.innerHeight;
      // Calculate the available height by subtracting the height of other elements if necessary
      const availableHeight =
        windowHeight - 332; /* subtract other elements height */
      // Set the max height of the table container
      setMaxTableHeight(availableHeight);
    };

    // Call the function initially and on window resize
    calculateMaxTableHeight();
    window.addEventListener("resize", calculateMaxTableHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateMaxTableHeight);
    };
  }, []);
  // const handleMonthChange = (selectedDate) => {
  //   console.log("currentDate0", selectedDate);
  //   //setSelectedMonth(selectedDate);
  //   getDetailsHeaderKPIData(selectedDate);
  // };
  // const handleYearChange = (selectedDate) => {
  //   console.log("currentDateYear", selectedDate);
  //   //setSelectedMonth(selectedDate);
  //   getDetailsHeaderKPIData(selectedDate);
  // };
  // function convertStartDate(selectedDate) {
  //   let startDate = "";
  //   let endDate = "";
  //   if (activeCalendarTab == 0) {
  //     startDate = "2024-01-01"; // Default value for startDate
  //     endDate = "2024-01-31";
  //   }
  //   if (activeCalendarTab == 1) {
  //     startDate = "2024-01-01"; // Default value for startDate
  //     endDate = "2024-03-31";
  //   }

  //   if (activeCalendarTab == 2) {
  //     startDate = "2024-01-01"; // Default value for startDate
  //     endDate = "2024-12-31";
  //   }

  //   if (selectedDate === "Jan 2023") {
  //     startDate = "2023-01-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-01-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Feb 2023") {
  //     startDate = "2023-02-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-02-28";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Mar 2023") {
  //     startDate = "2023-03-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-03-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Apr 2023") {
  //     startDate = "2023-04-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-04-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "May 2023") {
  //     startDate = "2023-05-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-05-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Jun 2023") {
  //     startDate = "2023-06-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-06-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Jul 2023") {
  //     startDate = "2023-07-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-07-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Aug 2023") {
  //     startDate = "2023-08-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-08-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Sep 2023") {
  //     startDate = "2023-09-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-09-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Oct 2023") {
  //     startDate = "2023-10-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-10-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Nov 2023") {
  //     startDate = "2023-11-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-11-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Dec 2023") {
  //     startDate = "2023-12-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-12-31";
  //     //setEndDate(endDate);
  //   }
  //   console.log("currentDate1", selectedDate);
  //   if (selectedDate === "Jan 2024") {
  //     startDate = "2024-01-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-01-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Feb 2024") {
  //     startDate = "2024-02-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-02-29";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Mar 2024") {
  //     startDate = "2024-03-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-03-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Apr 2024") {
  //     startDate = "2024-04-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-04-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "May 2024") {
  //     startDate = "2024-05-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-05-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Jun 2024") {
  //     startDate = "2024-06-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-06-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Jul 2024") {
  //     startDate = "2024-07-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-07-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Aug 2024") {
  //     startDate = "2024-08-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-08-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Sep 2024") {
  //     startDate = "2024-09-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-09-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Oct 2024") {
  //     startDate = "2023-10-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-10-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Nov 2024") {
  //     startDate = "2024-11-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-11-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Dec 2024") {
  //     startDate = "2024-12-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-12-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q1 2023") {
  //     startDate = "2023-01-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-03-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q2 2023") {
  //     startDate = "2023-04-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-06-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q3 2023") {
  //     startDate = "2023-07-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-09-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q4 2023") {
  //     startDate = "2023-10-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-12-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q1 2024") {
  //     startDate = "2024-01-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-03-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q2 2024") {
  //     startDate = "2024-04-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-06-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q3 2024") {
  //     startDate = "2024-07-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-09-30";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "Q4 2024") {
  //     startDate = "2024-10-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-12-31";
  //     //setEndDate(endDate);
  //   }
  //   // if (startDate === "2017") {
  //   //   return "2017-01-01";
  //   // }
  //   // if (startDate === "2018") {
  //   //   return "2018-01-01";
  //   // }
  //   // if (startDate === "2019") {
  //   //   return "2019-01-01";
  //   // }
  //   // if (startDate === "2020") {
  //   //   return "2020-01-01";
  //   // }
  //   // if (startDate === "2021") {
  //   //   return "2021-01-01";
  //   // }
  //   // if (startDate === "2022") {
  //   //   return "2022-01-01";
  //   // }
  //   if (selectedDate === "2023") {
  //     startDate = "2023-01-01";
  //     //setStartDate(startDate);
  //     endDate = "2023-12-31";
  //     //setEndDate(endDate);
  //   }
  //   if (selectedDate === "2024") {
  //     startDate = "2024-01-01";
  //     //setStartDate(startDate);
  //     endDate = "2024-12-31";
  //     //setEndDate(endDate);
  //   }
  //   return { startDate, endDate };
  // }
  // Access parameters from the URL
  useEffect(() => {
    const originalDateString = settlementDate ? settlementDate : "";
    let originalDate = moment.utc(originalDateString);
    const month = moment(originalDate).format("MMM");
    const day = moment(originalDate).format("DD");
    const year = moment(originalDate).year();
    const formattedDate = `${month} ${day}, ${year}`;
    console.log("setStatementDate1", formattedDate);
    setStatementDate(formattedDate);
    setNewUploadId(uploadId);
    setNewSettelmentDate(settlementDate);

    if (uploadId != 0) {
      getSettlementsListDataAPI();
      getDetailsHeaderKPIData();
    }
  }, [uploadId]);
  const getDetailsHeaderKPIData = (selectedDate) => {
    console.log("currentDate", selectedDate);
    //const selectedDate = selectedMonth;
    //let { startDate, endDate } = convertStartDate(selectedDate);
    // console.log("currentDate2", startDate);
    // console.log("currentDate3", endDate);
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/dashboard/kpi?upload_id=${uploadId}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getSettelmentsDetailsHeaderKPIData(uploadId)
      .then((response) => {
        //console.log("insideif", response);
        console.log("DetailsHeaderKPIData", response.data);
        console.log("DetailsHeaderKPIData1", response.data.gross_revenue);
        setGrossRevenue(response.data.gross_revenue);
        setDriverPayments(response.data.driver_payments);
        setGrossMargin(response.data.gross_margin);
        setHeaderRPM(response.data.rpm);
        setMilesLoaded(response.data.miles_loaded);
        setLoadsDelivered(response.data.loads_delivered);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const getSettlementsListDataAPI = () => {
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/settlements/${uploadId}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getSettlementsListData(uploadId)
      .then((response) => {
        //console.log("insideif", response);
        console.log("getSettlementsListData", response.data);
        setSettlementsListOriginalData(response.data ? response.data : "");
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const [
    currentPageSettlementsDetailsPOC,
    setCurrentPageSettlementsDetailsPOC,
  ] = useState(1);
  const [
    itemsPerPageSettlementsDetailsPOC,
    setItemsPerPageSettlementsDetailsPOC,
  ] = useState(50);
  const handlePageChange = (pageNumber) => {
    setCurrentPageSettlementsDetailsPOC(pageNumber);
  };
  const handleItemsPerPageChange = (perPage) => {
    setItemsPerPageSettlementsDetailsPOC(perPage);
    setCurrentPageSettlementsDetailsPOC(1); // Reset to the first page when changing items per page
  };
  const handleNavigateAway = () => {
    // Save current page and items per page
    // You can save these values to local storage or any other persistent storage
    localStorage.setItem(
      "currentPageSettlementsDetailsPOC",
      currentPageSettlementsDetailsPOC
    );
    // localStorage.setItem(
    //   "itemsPerPageSettlementsDetailsPOC",
    //   itemsPerPageSettlementsDetailsPOC
    // );
  };
  const handleReturnSettlementsDetailsPOC = () => {
    // Retrieve saved page and items per page
    const savedPage = localStorage.getItem("currentPageSettlementsDetailsPOC");
    // const savedItemsPerPage = localStorage.getItem(
    //   "itemsPerPageSettlementsDetailsPOC"
    // );
    setCurrentPageSettlementsDetailsPOC(savedPage ? parseInt(savedPage) : 1);
    // setItemsPerPageSettlementsDetailsPOC(
    //   savedItemsPerPage ? parseInt(savedItemsPerPage) : 50
    // );
  };
  return (
    <React.Fragment>
      <div className="detailsPage">
        <Container fluid>
          <div className="">
            <Row xl={12} md={12} sm={12} xs={12}>
              <Col xl={12} md={12} sm={12} xs={12}>
                <div className="stickyRowSettlementsDetails">
                  <div className="headerSettlementsDetails">
                    <Breadcrumbs items={breadcrumbItems} />
                    {/* <div
                      className="backToDrivers"
                      style={{ display: "flex", width: "100%" }}
                    >
                      {" "}
                      <img
                        src={backRightArrow}
                        className="backRightArrow"
                      ></img>
                      <Link to="/settlement" className="backLink">
                        Weekly Settlements
                      </Link>
                    </div> */}
                    <div style={{ marginTop: "8px" }}>
                      <Title name={statementDate} type={"page"} />
                    </div>
                    <div className="serialNumbersSettlements">
                      <div className="settlementId">Upload Id:</div>
                      <div className="settlementValue">{uploadId}</div>
                    </div>
                  </div>
                  <div style={{ marginTop: "16px" }}>
                    <DetailsHeader data={driverData} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "24px",
                    }}
                    className="tableTitleContainerSettlementsDetails"
                  >
                    {" "}
                    <div style={{ flex: "1" }}>
                      <Title
                        name={`Settlements (${settelmentsListOriginalData.length})`}
                        type={"table"}
                      />
                    </div>
                    {/* <div style={{ flex: "" }} className="searchBox">
                      <img src={searchIcon} />
                      <input
                        type="text"
                        placeholder="Search settlement id or driver name"
                        className="searchTextStyle"
                        style={{
                          border: "none",
                          background: "#fcfcfc",
                          padding: "0",
                        }}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="tableContainerSettlementsDetails">
                  <div
                    className="driversTableContainerSettlementsDetails"
                    style={{
                      maxHeight: `${maxTableHeight}px`,
                      padding: "0 16px 0 16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div className="recentSettelmentsTableContainer">
                      <DriversTablePOC
                        headers={settlementsTableHeaders}
                        data={settlementsTableData}
                        activeTab={activeTab}
                        rowClick={true}
                        tableName={"settelmentsDetailsPOC"}
                        settelmentDate={settlementDate}
                        uploadId={uploadId}
                        paginationEnabled={true}
                        currentPage={currentPageSettlementsDetailsPOC}
                        itemsPerPage={itemsPerPageSettlementsDetailsPOC}
                        onPageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        onNavigateAway={handleNavigateAway}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SettlementsDetailsPOC;
